import Rails from "@rails/ujs"
import { ethers } from 'ethers';

require('packs/jquery-3.5.1.min');
//require('packs/bootstrap.bundle.min.js');
global.toastr = require('toastr');
require('packs/ethereum/web3.js');
require('packs/formatter.js');
require('packs/jquery.magnific-popup.min.js');
require('packs/script.js');

global.BigNumber = require('bignumber.js');

let ownerAddress = gon.ownerAddress;
let isAdmin = gon.isAdmin

Rails.start()

$(document).ready(function (e) {
    window.ethers = ethers;
  setProvider();

//   if (window.ethers && window.ethers.providers.Web3Provider) {
//     checkNetwork();
//   }

  function setProvider() {
    if (!window.ethereum) return;
    window.provider = new ethers.providers.Web3Provider(window.ethereum);
  }

  // window.show_modal = async function show_modal(id) {
	// 	$.magnificPopup.open({
	// 		closeOnBgClick: false,
	// 		enableEscapeKey: false,
	// 		items: {
	// 			src: id
	// 		},
	// 		type: 'inline'
	// 	});
	// }

});

$(document).on("click", ".create_nft", function (e) {
  if (window.ethereum && window.ethereum.selectedAddress && isAdmin) {
    if (window.ethereum && window.ethereum.selectedAddress != ownerAddress) {
      alert('You dont have permission connect admin wallet');
      window.location.href = '/admin/collections/nft_lists';
    } else if (window.ethereum && window.ethereum.selectedAddress == ownerAddress) {
      window.location.href = '/admin/collections/new';
    }
  } else {
    alert('Please connect your wallet to proceed');
    window.location.href = '/admin/collections/nft_lists';
  }
});

$(document).on("click", ".triggerCollectionValidation", function (e) {
  e.preventDefault()
  var form = $("#collectionCreateForm")[0]
  if (form.checkValidity()) {
      $("#submitCollection").click();
      $("#collectionCreateForm :input").prop("disabled", true);
  } else {
    if ($('#file-1').val() === '') {
      return toastr.error('Please select collection file')
    } else if ($("#collection-category option:selected").length === 0) {
      return toastr.error('Please select categories')
    } else if ($('#collection-name').val() === '') {
      return toastr.error('Please provide collection name')
    } else if ($('#description').val() === '') {
      return toastr.error('Please provide collection description')
    } else {
      toastr.error('Please fill all required fields.')
    }
  }
})

$(document).on("click", ".passwordValidation", function (e) {
  e.preventDefault()
    if($('#password').val() == '' ||  $('#confirm_password').val()== ''){
      return alert('password field invalid!')
    }else if($('#password').val() != $('#confirm_password').val()){
      return alert('wrong password. Please check')
    }else{
      $("#submitPassword").click();
    }
});

$(document).on("change", "#discountOn", function () {
  if ($(this).is(":checked")) {
    $('#discountOn').val(true);
    $('#myDiscount').attr("readonly", false);
    alert('please enter the discount price')
  } else {
    $('#discountOn').val(false);
    $('#myDiscount').val(0.0);
    $('#myDiscount').attr("readonly", true);
  }
});

$(document).on("change", "#claimOn", function () {
  if ($(this).is(":checked")) {
    $('#claimOn').val(true);
  } else {
    $('#claimOn').val(false);
  }
});

$(document).on("click", ".show-login-message", function (e) {
  alert('Please connect your wallet to proceed.')
  e.preventDefault();
});



